module.exports = __webpack_public_path__ + "img/foodable_team.3c6d8e1c.jpeg";